"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SampleOrParentButton = void 0;
var OpenProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SampleOrParentButton = ({
  fullProductInfoTitle,
  sampleProductTitle,
  disabled,
  parentProducts,
  placement,
  sample,
  isPrimary,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const sampleProductCode = (0, _utils.getSampleProductCode)(sample);
  const parentProductCode = (0, _utils.getParentProductCode)(parentProducts);
  const onButtonClick = (0, _react.useCallback)(() => {
    if (parentProductCode) {
      (0, _utils.goToFullProduct)(parentProductCode);
    } else if (sampleProductCode) {
      window.dispatchEvent(new CustomEvent(OpenProductInfoDialog.Name, {
        detail: {
          mode: OpenProductInfoDialog.DialogMode.StandardBuy,
          placement,
          productCodes: [sampleProductCode]
        }
      }));
    }
  }, [parentProductCode, placement, sampleProductCode]);
  if (!sampleProductCode && !parentProductCode) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    "data-testid": getTestId(_constants.SAMPLE_OR_PARENT_BUTTON),
    disabled: disabled,
    color: isPrimary ? 'primary' : 'default',
    variant: isPrimary ? 'contained' : 'outlined',
    startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.WelcomeKit, {}),
    onClick: onClick ?? onButtonClick,
    children: parentProductCode ? fullProductInfoTitle : sampleProductTitle
  });
};
exports.SampleOrParentButton = SampleOrParentButton;
